import { useContext, useEffect, useState } from 'react';
import {  useHistory } from 'react-router-dom';
import { UserContext } from '../../../context';
import { AuthService } from '../../../services';


export const UpaSession = () =>{
 
      const { setUser } = useContext(UserContext);

  const [sessionData, setSessionData] = useState("");
  const history = useHistory();

    const params = new URLSearchParams(window.location.search)
      const sId = params.get("sId");
  let stateObject;



  const getSessionData = async () => {
    const data = await AuthService.upaSessionAuth(sId);
     if(data?.status === 200){

      setSessionData(data?.data?.data?.sessionData);
    }else{
        localStorage.removeItem('user')
        history.push("/signIn");
    }
  };

  useEffect(() => {
    if (sId) {
      getSessionData();
    }
  }, []);

  const assignRole = (roles) => {
      if(roles.includes("SUPERADMIN")){
        return "SUPERADMIN"
      }
      else if(roles.includes("ADMIN")){
        return "ADMIN"
      }
      else{
        return ""
      }
    }
    useEffect(() => {
    // once we get 'user' data it will be set on sessionStorage on BB.
    if (sessionData) {
      try {
        const sessionObj = JSON.parse(sessionData);
        // validating the timestamp only for one minute
        if (Date.now() - sessionObj?.currentTimeStamp >= 60 * 1000) {
                     history.push("/signIn");

          return;
        }

        stateObject = {
          username: sessionObj?.email,
          tokens: {
            ...sessionObj.tokens,
            accessToken: {
              ...sessionObj.tokens.accessToken,
              jwtToken: sessionObj.tokens.accessToken.token,
            },
          },
          name: sessionObj?.name,
          authenticated: true,
          loggedIn: true,
          role: assignRole(sessionObj.roles),
          isSSO: sessionObj?.isSSO,
          appId: sessionObj?.appId
        };
        localStorage.setItem("user", JSON.stringify(stateObject));
        setUser(stateObject);
              history.push("/interstitial");

      } catch (e) {
        console.error("Decryption failed:", e);
             history.push("/signIn");

      }
    }
  }, [sessionData]);
}